<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>欢迎回来</span>
      </div>
      <div>
        <Panel :title="'关注的艺术家'">
          <Artist :list="likeArtistList" :swiper="true" :swiper-option="swiperOption"></Artist>
        </Panel>
        <Panel :title="'浏览足迹'" v-if="prolist.length>0">
          <ProList :list="prolist"></ProList>
        </Panel>
      </div>
    </el-card>
  </div>
</template>
<script>
import Panel from '../../components/panel.vue'
import Artist from '../../components/artist.vue'
import ProList from '../../components/prolist.vue';
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();

export default {
  name: 'index',
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      likeArtistList: [],
      prolist: [],
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 4,
        autoplay: false,
        pagination: '.swiper-pagination',
      }
    }
  },
  components: {
    Artist,
    Panel,
    ProList
  },
  methods: {
    getLIkeArtistList() {
      let _this = this;
      usercenter.myLikeArtistList({
        CustomerId: _this.user ? this.user.id : "",
        PageIndex: _this.pageIndex,
        PageSize: _this.pageSize
      }).then((res) => {
        _this.likeArtistList = res
      })
    }
  },
  created() {
    this.getLIkeArtistList()
  },

}
</script>
